module.exports = __webpack_public_path__ + "static/media/slots.7f9c2a67.svg";